<div class="mt-10 text-center font-bold overflow-hidden">
  Forbidden error detected when trying to get your permissions
</div>
